<template>
  <div class="list-con-m">
    <leftM ref="leftMRef" @cateData="cateData"></leftM>
    <div class="right-m-con message-board">
      <div class="msg-b-con">
        <Loading :isShow="isShow" :label="labelMsg"></Loading>
        <b-alert :variant="variant" fade v-model="showVariant">{{ comMsg}}</b-alert>
        <div class="msg-form">
          <b-form @submit="subData" @reset="resetFun">
            <div class="input-m">
              <div class="label-t">用户名：</div>
              <b-input required trim class="input-c" maxlength="20" v-model="msgData.name" placeholder=""></b-input>
            </div>
            <div class="input-m">
              <div class="label-t">联系电话：</div>
              <b-input required trim class="input-c" maxlength="20" v-model="msgData.tel" placeholder=""></b-input>
            </div>
            <div class="input-m">
              <div class="label-t">E-mail：</div>
              <b-input required trim class="input-c" maxlength="50" v-model="msgData.email" placeholder=""></b-input>
            </div>
            <div class="input-m">
              <div class="label-t">主题：</div>
              <b-input required trim class="input-c" maxlength="30" v-model="msgData.title" placeholder=""></b-input>
            </div>
            <div class="input-m">
              <div class="label-t">内容：</div>
              <b-form-textarea required id="textarea" maxlength="100" class="input-txt"  v-model="msgData.content" trim rows="6" no-resize></b-form-textarea>
            </div>
            <div class="input-m">
              <div class="label-t"></div>
              <b-button class="f-btn ser-btn" type="submit" variant="light">提交</b-button>
              <b-button class="f-btn reset-btn" type="reset" variant="light">重置</b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import leftM from "@/components/leftM";
const msgData = {name:'',email:'',tel:'',title:'',content:''};
export default {
  name: "MessageBoard",
  components:{
    leftM
  },
  data(){
    return {
      typeId:null,
      cateData: {
        _child: null,
        indexId: 0
      },
      domain:this.ApiUrl,
      isShow:false,
      labelMsg:'',
      msgData:JSON.parse(JSON.stringify(msgData)),
      showVariant:false,
      variant: 'danger',
      comMsg:''
    }
  },
  watch:{
    cateData(e){
      this.$refs.leftMRef.initData(e);
    },
    showVariant(e){
      if(e){
        setTimeout(()=>{
          this.showVariant = false;
        },3000)
      }
    }
  },
  mounted() {
    this.init();
    this.$refs.leftMRef.initData(this.cateData);
  },
  methods:{
    init(){
      this.isShow = true;
      this.requestApi('messageBoardInit', {}).then((res) => {
        if(res.status==1){
          this.cateData = res.cateData;
        }
        this.$nextTick(()=>{
          this.isShow = false;
        })
      })
    },
    resetFun(evt){
      evt.preventDefault()
      this.msgData = JSON.parse(JSON.stringify(msgData));
    },
    subData(evt){
      evt.preventDefault();
      if(this.isShow) return false;
      this.isShow = true;
      this.labelMsg = '提交中...'
      this.requestApi('commitMessageBoard', {msgData:this.msgData}).then((res) => {
        this.comMsg = res.msg;
        if(res.status==1){
          this.variant = 'success';
          this.msgData = JSON.parse(JSON.stringify(msgData));
        }else{
          this.variant = "danger";
        }
        this.showVariant = true;
        this.$nextTick(()=>{
          this.isShow = false;
          this.labelMsg = ''
        })
      })
    }
  }
}
</script>

<style lang="scss">
@import "~/src/assets/css/message_board";
</style>